var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-white rounded-lg shadow w-full h-full dark:bg-gray-900"},[_c('div',{staticClass:"mx-auto p-4 md:py-8"},[_c('span',{staticClass:"block text-sm text-gray-500 text-center dark:text-gray-400"},[_vm._v("Copyright © 2023 Glitzy | Webcam studio | By Trend Studio All rights reserved. ")])])])
}]

export { render, staticRenderFns }